module.exports = __webpack_public_path__ + "static/img/user.e7885c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePage/img/user.png
// module id = 2AVj
// module chunks = 1